import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelText as _vModelText, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-10" }
const _hoisted_2 = { class: "card-body d-flex align-items-center py-8" }
const _hoisted_3 = { class: "d-flex h-80px w-80px flex-shrink-0 flex-center position-relative" }
const _hoisted_4 = { class: "svg-icon svg-icon-primary position-absolute opacity-15" }
const _hoisted_5 = { class: "svg-icon svg-icon-3x svg-icon-primary position-absolute" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "ms-6" }, [
  /*#__PURE__*/_createVNode("p", { class: "list-unstyled text-gray-600 fw-bold fs-6 p-0 m-0" }, " The layout builder is to assist your set and configure your preferred project layout specifications and preview it in real time and export the HTML template with its includable partials of this demo. The downloaded version does not include the assets folder since the layout builder's main purpose is to help to generate the final HTML code without hassle. ")
], -1)
const _hoisted_7 = { class: "card mb-10" }
const _hoisted_8 = { class: "card-header card-header-stretch" }
const _hoisted_9 = {
  class: "nav nav-stretch nav-line-tabs fw-bold border-0",
  role: "tablist",
  id: "kt_layout_builder_tabs",
  ref: "kt_layout_builder_tabs"
}
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = { class: "nav-item" }
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = { class: "nav-item" }
const _hoisted_15 = { class: "nav-item" }
const _hoisted_16 = { class: "card-body" }
const _hoisted_17 = {
  class: "tab-content pt-3",
  id: "kt_tabs"
}
const _hoisted_18 = { class: "row mb-10" }
const _hoisted_19 = /*#__PURE__*/_createVNode("label", { class: "col-lg-3 col-form-label text-lg-end" }, "Loader:", -1)
const _hoisted_20 = { class: "col-lg-9 col-xl-4" }
const _hoisted_21 = { class: "form-check form-check-custom form-check-solid form-switch mb-2" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "form-text text-muted" }, " Display Page Loader ", -1)
const _hoisted_23 = { class: "row mb-10" }
const _hoisted_24 = /*#__PURE__*/_createVNode("label", { class: "col-lg-3 col-form-label text-lg-end" }, "Loader Type:", -1)
const _hoisted_25 = { class: "col-lg-9 col-xl-4" }
const _hoisted_26 = /*#__PURE__*/_createVNode("option", { value: "default" }, "Spinner", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("option", { value: "spinner-message" }, "Spinner & Message", -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("option", { value: "spinner-logo" }, "Spinner & Logo", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "form-text text-muted" }, " Select Page Loader type ", -1)
const _hoisted_30 = { class: "row mb-10" }
const _hoisted_31 = /*#__PURE__*/_createVNode("label", { class: "col-lg-3 col-form-label text-lg-end" }, "Fixed Header:", -1)
const _hoisted_32 = { class: "col-lg-9 col-xl-4" }
const _hoisted_33 = { class: "form-check form-check-custom form-check-solid form-switch mb-5" }
const _hoisted_34 = /*#__PURE__*/_createVNode("span", { class: "form-check-label text-muted" }, "Desktop", -1)
const _hoisted_35 = { class: "form-check form-check-custom form-check-solid form-switch mb-5" }
const _hoisted_36 = /*#__PURE__*/_createVNode("span", { class: "form-check-label text-muted" }, "Tablet & Mobile", -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "form-text text-muted" }, " Enable fixed header ", -1)
const _hoisted_38 = { class: "row mb-10" }
const _hoisted_39 = /*#__PURE__*/_createVNode("label", { class: "col-lg-3 col-form-label text-lg-end" }, "Menu Icon:", -1)
const _hoisted_40 = { class: "col-lg-9 col-xl-4" }
const _hoisted_41 = /*#__PURE__*/_createVNode("option", { value: "svg" }, "SVG Icon", -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("option", { value: "font" }, "Font Icon", -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { class: "form-text text-muted" }, " Select menu icon type. ", -1)
const _hoisted_44 = { class: "row mb-10" }
const _hoisted_45 = /*#__PURE__*/_createVNode("label", { class: "col-lg-3 col-form-label text-lg-end" }, "Width:", -1)
const _hoisted_46 = { class: "col-lg-9 col-xl-4" }
const _hoisted_47 = /*#__PURE__*/_createVNode("option", { value: "fluid" }, "Fluid", -1)
const _hoisted_48 = /*#__PURE__*/_createVNode("option", { value: "fixed" }, "Fixed", -1)
const _hoisted_49 = /*#__PURE__*/_createVNode("div", { class: "form-text text-muted" }, " Select header width type. ", -1)
const _hoisted_50 = { class: "row mb-10" }
const _hoisted_51 = /*#__PURE__*/_createVNode("label", { class: "col-lg-3 col-form-label text-lg-end" }, "Display:", -1)
const _hoisted_52 = { class: "col-lg-9 col-xl-4" }
const _hoisted_53 = { class: "form-check form-check-custom form-check-solid form-switch mb-2" }
const _hoisted_54 = /*#__PURE__*/_createVNode("div", { class: "form-text text-muted" }, " Display Subheader ", -1)
const _hoisted_55 = { class: "row mb-10" }
const _hoisted_56 = /*#__PURE__*/_createVNode("label", { class: "col-lg-3 col-form-label text-lg-end" }, "Width:", -1)
const _hoisted_57 = { class: "col-lg-9 col-xl-4" }
const _hoisted_58 = /*#__PURE__*/_createVNode("option", { value: "fluid" }, "Fluid", -1)
const _hoisted_59 = /*#__PURE__*/_createVNode("option", { value: "fixed" }, "Fixed", -1)
const _hoisted_60 = /*#__PURE__*/_createVNode("div", { class: "form-text text-muted" }, " Select layout width type. ", -1)
const _hoisted_61 = { class: "row mb-10" }
const _hoisted_62 = /*#__PURE__*/_createVNode("label", { class: "col-lg-3 col-form-label text-lg-end" }, "Theme:", -1)
const _hoisted_63 = { class: "col-lg-9 col-xl-4" }
const _hoisted_64 = /*#__PURE__*/_createVNode("option", { value: "dark" }, "Dark", -1)
const _hoisted_65 = /*#__PURE__*/_createVNode("option", { value: "light" }, "Light", -1)
const _hoisted_66 = /*#__PURE__*/_createVNode("div", { class: "form-text text-muted" }, " Set aside theme ", -1)
const _hoisted_67 = { class: "row mb-10" }
const _hoisted_68 = /*#__PURE__*/_createVNode("label", { class: "col-lg-3 col-form-label text-lg-end" }, "Menu Icon:", -1)
const _hoisted_69 = { class: "col-lg-9 col-xl-4" }
const _hoisted_70 = /*#__PURE__*/_createVNode("option", { value: "svg" }, "SVG Icon", -1)
const _hoisted_71 = /*#__PURE__*/_createVNode("option", { value: "font" }, "Font Icon", -1)
const _hoisted_72 = /*#__PURE__*/_createVNode("div", { class: "form-text text-muted" }, " Select menu icon type. ", -1)
const _hoisted_73 = { class: "row mb-10" }
const _hoisted_74 = /*#__PURE__*/_createVNode("label", { class: "col-lg-3 col-form-label text-lg-end" }, "Display:", -1)
const _hoisted_75 = { class: "col-lg-9 col-xl-4" }
const _hoisted_76 = { class: "switch switch-icon" }
const _hoisted_77 = { class: "form-check form-check-custom form-check-solid form-switch mb-2" }
const _hoisted_78 = /*#__PURE__*/_createVNode("div", { class: "form-text text-muted" }, " Display Aside ", -1)
const _hoisted_79 = { class: "row mb-10" }
const _hoisted_80 = /*#__PURE__*/_createVNode("label", { class: "col-lg-3 col-form-label text-lg-end" }, "Minimized:", -1)
const _hoisted_81 = { class: "col-lg-9 col-xl-4" }
const _hoisted_82 = { class: "switch switch-icon" }
const _hoisted_83 = { class: "form-check form-check-custom form-check-solid form-switch mb-2" }
const _hoisted_84 = /*#__PURE__*/_createVNode("div", { class: "form-text text-muted" }, " Minimize secondary panel by default ", -1)
const _hoisted_85 = { class: "row mb-10" }
const _hoisted_86 = /*#__PURE__*/_createVNode("label", { class: "col-lg-3 col-form-label text-lg-end" }, "Width:", -1)
const _hoisted_87 = { class: "col-lg-9 col-xl-4" }
const _hoisted_88 = /*#__PURE__*/_createVNode("option", { value: "fluid" }, "Fluid", -1)
const _hoisted_89 = /*#__PURE__*/_createVNode("option", { value: "fixed" }, "Fixed", -1)
const _hoisted_90 = /*#__PURE__*/_createVNode("div", { class: "form-text text-muted" }, " Select layout width type. ", -1)
const _hoisted_91 = { class: "row mb-10" }
const _hoisted_92 = /*#__PURE__*/_createVNode("label", { class: "col-lg-3 col-form-label text-lg-end" }, "Width:", -1)
const _hoisted_93 = { class: "col-lg-9 col-xl-4" }
const _hoisted_94 = /*#__PURE__*/_createVNode("option", { value: "fluid" }, "Fluid", -1)
const _hoisted_95 = /*#__PURE__*/_createVNode("option", { value: "fixed" }, "Fixed", -1)
const _hoisted_96 = /*#__PURE__*/_createVNode("div", { class: "form-text text-muted" }, " Select layout width type. ", -1)
const _hoisted_97 = { class: "card-footer py-6" }
const _hoisted_98 = { class: "row" }
const _hoisted_99 = /*#__PURE__*/_createVNode("div", { class: "col-lg-3" }, null, -1)
const _hoisted_100 = { class: "col-lg-9" }
const _hoisted_101 = /*#__PURE__*/_createStaticVNode("<input type=\"hidden\" id=\"kt_layout_builder_tab\" name=\"layout-builder[tab]\"><input type=\"hidden\" id=\"kt_layout_builder_action\" name=\"layout-builder[action]\"><button type=\"submit\" id=\"kt_layout_builder_preview\" class=\"btn btn-primary me-2\"><span class=\"indicator-label\"> Preview </span><span class=\"indicator-progress\"> Please wait... <span class=\"spinner-border spinner-border-sm align-middle ms-2\"></span></span></button>", 3)
const _hoisted_104 = { class: "card" }
const _hoisted_105 = { class: "card-body p-10 p-lg-15" }
const _hoisted_106 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "overview"
}, " Generated config ", -1)
const _hoisted_107 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" This config is used as a "),
  /*#__PURE__*/_createVNode("b", null, "YellowBeard"),
  /*#__PURE__*/_createTextVNode(" layout config, you can update default values inside file "),
  /*#__PURE__*/_createVNode("code", null, "@/src/core/config/DefaultLayoutConfig.ts")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("span", _hoisted_4, [
            _createVNode(_component_inline_svg, {
              src: "@/assets/media/icons/duotone/Layout/Layout-polygon.svg",
              class: "h-80px w-80px"
            })
          ]),
          _createVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "@/assets/media/icons/duotone/Tools/Tools.svg" })
          ])
        ]),
        _hoisted_6
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode("ul", _hoisted_9, [
          _createVNode("li", _hoisted_10, [
            _createVNode("a", {
              class: ["nav-link", { active: _ctx.tabIndex === 0 }],
              "data-bs-toggle": "tab",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setActiveTab($event))),
              "data-tab-index": "0",
              href: "#kt_builder_main",
              role: "tab"
            }, " Main ", 2)
          ]),
          _createVNode("li", _hoisted_11, [
            _createVNode("a", {
              class: ["nav-link", { active: _ctx.tabIndex === 1 }],
              "data-bs-toggle": "tab",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setActiveTab($event))),
              "data-tab-index": "1",
              href: "#kt_builder_header",
              role: "tab"
            }, " Header ", 2)
          ]),
          _createVNode("li", _hoisted_12, [
            _createVNode("a", {
              class: ["nav-link", { active: _ctx.tabIndex === 2 }],
              "data-bs-toggle": "tab",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setActiveTab($event))),
              "data-tab-index": "2",
              href: "#kt_builder_subheader",
              role: "tab"
            }, " Subheader ", 2)
          ]),
          _createVNode("li", _hoisted_13, [
            _createVNode("a", {
              class: ["nav-link", { active: _ctx.tabIndex === 3 }],
              "data-bs-toggle": "tab",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setActiveTab($event))),
              "data-tab-index": "3",
              href: "#kt_builder_aside",
              role: "tab"
            }, " Aside ", 2)
          ]),
          _createVNode("li", _hoisted_14, [
            _createVNode("a", {
              class: ["nav-link", { active: _ctx.tabIndex === 4 }],
              "data-bs-toggle": "tab",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setActiveTab($event))),
              "data-tab-index": "4",
              href: "#kt_builder_content",
              role: "tab"
            }, " Content ", 2)
          ]),
          _createVNode("li", _hoisted_15, [
            _createVNode("a", {
              class: ["nav-link", { active: _ctx.tabIndex === 5 }],
              "data-bs-toggle": "tab",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setActiveTab($event))),
              "data-tab-index": "5",
              href: "#kt_builder_footer",
              role: "tab"
            }, " Footer ", 2)
          ])
        ], 512)
      ]),
      _createVNode("form", {
        class: "form",
        id: "kt_layout_builder_form",
        onSubmit: _cache[27] || (_cache[27] = ($event: any) => (_ctx.submit($event)))
      }, [
        _createVNode("div", _hoisted_16, [
          _createVNode("div", _hoisted_17, [
            _createVNode("div", {
              class: ["tab-pane", { active: _ctx.tabIndex === 0 }],
              id: "kt_builder_main"
            }, [
              _createVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode("div", _hoisted_20, [
                  _createVNode("div", _hoisted_21, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.config.loader.display = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.config.loader.display]
                    ])
                  ]),
                  _hoisted_22
                ])
              ]),
              _createVNode("div", _hoisted_23, [
                _hoisted_24,
                _createVNode("div", _hoisted_25, [
                  _withDirectives(_createVNode("select", {
                    class: "form-select form-select-solid",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.config.loader.type = $event))
                  }, [
                    _hoisted_26,
                    _hoisted_27,
                    _hoisted_28
                  ], 512), [
                    [_vModelSelect, _ctx.config.loader.type]
                  ]),
                  _hoisted_29
                ])
              ])
            ], 2),
            _createVNode("div", {
              class: ["tab-pane", { active: _ctx.tabIndex === 1 }],
              id: "kt_builder_header"
            }, [
              _createVNode("div", _hoisted_30, [
                _hoisted_31,
                _createVNode("div", _hoisted_32, [
                  _withDirectives(_createVNode("input", {
                    type: "hidden",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.config.header.fixed.desktop = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.config.header.fixed.desktop]
                  ]),
                  _withDirectives(_createVNode("input", {
                    type: "hidden",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (
										_ctx.config.header.fixed.tabletAndMobile
									 = $event))
                  }, null, 512), [
                    [_vModelText, 
										_ctx.config.header.fixed.tabletAndMobile
									]
                  ]),
                  _createVNode("label", _hoisted_33, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.config.header.fixed.desktop = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.config.header.fixed.desktop]
                    ]),
                    _hoisted_34
                  ]),
                  _createVNode("label", _hoisted_35, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (
											_ctx.config.header.fixed.tabletAndMobile
										 = $event))
                    }, null, 512), [
                      [_vModelCheckbox, 
											_ctx.config.header.fixed.tabletAndMobile
										]
                    ]),
                    _hoisted_36
                  ]),
                  _hoisted_37
                ])
              ]),
              _createVNode("div", _hoisted_38, [
                _hoisted_39,
                _createVNode("div", _hoisted_40, [
                  _withDirectives(_createVNode("select", {
                    class: "form-select form-select-solid",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.config.header.menuIcon = $event))
                  }, [
                    _hoisted_41,
                    _hoisted_42
                  ], 512), [
                    [_vModelSelect, _ctx.config.header.menuIcon]
                  ]),
                  _hoisted_43
                ])
              ]),
              _createVNode("div", _hoisted_44, [
                _hoisted_45,
                _createVNode("div", _hoisted_46, [
                  _withDirectives(_createVNode("select", {
                    class: "form-select form-select-solid",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.config.header.width = $event))
                  }, [
                    _hoisted_47,
                    _hoisted_48
                  ], 512), [
                    [_vModelSelect, _ctx.config.header.width]
                  ]),
                  _hoisted_49
                ])
              ])
            ], 2),
            _createVNode("div", {
              class: ["tab-pane", { active: _ctx.tabIndex === 2 }],
              id: "kt_builder_subheader"
            }, [
              _createVNode("div", _hoisted_50, [
                _hoisted_51,
                _createVNode("div", _hoisted_52, [
                  _withDirectives(_createVNode("input", {
                    type: "hidden",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.config.toolbar.display = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.config.toolbar.display]
                  ]),
                  _createVNode("div", _hoisted_53, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.config.toolbar.display = $event)),
                      value: "true"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.config.toolbar.display]
                    ])
                  ]),
                  _hoisted_54
                ])
              ]),
              _createVNode("div", _hoisted_55, [
                _hoisted_56,
                _createVNode("div", _hoisted_57, [
                  _withDirectives(_createVNode("select", {
                    class: "form-select form-select-solid",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.config.toolbar.width = $event))
                  }, [
                    _hoisted_58,
                    _hoisted_59
                  ], 512), [
                    [_vModelSelect, _ctx.config.toolbar.width]
                  ]),
                  _hoisted_60
                ])
              ])
            ], 2),
            _createVNode("div", {
              class: ["tab-pane", { active: _ctx.tabIndex === 3 }],
              id: "kt_builder_aside"
            }, [
              _createVNode("div", _hoisted_61, [
                _hoisted_62,
                _createTextVNode(" " + _toDisplayString(_ctx.config) + " ", 1),
                _createVNode("div", _hoisted_63, [
                  _withDirectives(_createVNode("select", {
                    class: "form-select form-select-solid",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.config.aside.theme = $event))
                  }, [
                    _hoisted_64,
                    _hoisted_65
                  ], 512), [
                    [_vModelSelect, _ctx.config.aside.theme]
                  ]),
                  _hoisted_66
                ])
              ]),
              _createVNode("div", _hoisted_67, [
                _hoisted_68,
                _createVNode("div", _hoisted_69, [
                  _withDirectives(_createVNode("select", {
                    class: "form-select form-select-solid",
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.config.aside.menuIcon = $event))
                  }, [
                    _hoisted_70,
                    _hoisted_71
                  ], 512), [
                    [_vModelSelect, _ctx.config.aside.menuIcon]
                  ]),
                  _hoisted_72
                ])
              ]),
              _createVNode("div", _hoisted_73, [
                _hoisted_74,
                _createVNode("div", _hoisted_75, [
                  _createVNode("span", _hoisted_76, [
                    _withDirectives(_createVNode("input", {
                      type: "hidden",
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.config.aside.display = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.config.aside.display]
                    ]),
                    _createVNode("div", _hoisted_77, [
                      _withDirectives(_createVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.config.aside.display = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.config.aside.display]
                      ])
                    ])
                  ]),
                  _hoisted_78
                ])
              ]),
              _createVNode("div", _hoisted_79, [
                _hoisted_80,
                _createVNode("div", _hoisted_81, [
                  _createVNode("span", _hoisted_82, [
                    _withDirectives(_createVNode("input", {
                      type: "hidden",
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.config.aside.minimized = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.config.aside.minimized]
                    ]),
                    _createVNode("div", _hoisted_83, [
                      _withDirectives(_createVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.config.aside.minimized = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.config.aside.minimized]
                      ])
                    ])
                  ]),
                  _hoisted_84
                ])
              ])
            ], 2),
            _createVNode("div", {
              class: ["tab-pane", { active: _ctx.tabIndex === 4 }],
              id: "kt_builder_content"
            }, [
              _createVNode("div", _hoisted_85, [
                _hoisted_86,
                _createVNode("div", _hoisted_87, [
                  _withDirectives(_createVNode("select", {
                    class: "form-select form-select-solid",
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.config.content.width = $event))
                  }, [
                    _hoisted_88,
                    _hoisted_89
                  ], 512), [
                    [_vModelSelect, _ctx.config.content.width]
                  ]),
                  _hoisted_90
                ])
              ])
            ], 2),
            _createVNode("div", {
              class: ["tab-pane", { active: _ctx.tabIndex === 5 }],
              id: "kt_builder_footer"
            }, [
              _createVNode("div", _hoisted_91, [
                _hoisted_92,
                _createVNode("div", _hoisted_93, [
                  _withDirectives(_createVNode("select", {
                    class: "form-select form-select-solid",
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.config.footer.width = $event))
                  }, [
                    _hoisted_94,
                    _hoisted_95
                  ], 512), [
                    [_vModelSelect, _ctx.config.footer.width]
                  ]),
                  _hoisted_96
                ])
              ])
            ], 2)
          ])
        ]),
        _createVNode("div", _hoisted_97, [
          _createVNode("div", _hoisted_98, [
            _hoisted_99,
            _createVNode("div", _hoisted_100, [
              _hoisted_101,
              _createVNode("button", {
                onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.reset($event))),
                type: "button",
                id: "kt_layout_builder_reset",
                class: "btn btn-active-light btn-color-muted fw-bold"
              }, " Reset ")
            ])
          ])
        ])
      ], 32)
    ]),
    _createVNode("div", _hoisted_104, [
      _createVNode("div", _hoisted_105, [
        _hoisted_106,
        _hoisted_107,
        _createVNode(_component_CodeHighlighter, { lang: "json" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.config), 1)
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}